
import { baseURL } from '@/api/request'
import request from '@/api/request'
import Cookies from 'js-cookie'
import qs from 'qs'

//  获取教师集合
export const getTeacherList = params => {
  return request({
    url: 'admin/base/adm/baseUser/page',
    method: 'get',
    params
  })
}

//  获取协议列表
export const getDealList = params => {
  return request({
    url: 'order/adm/contractTemplate/getList',
    method: 'get',
    params
  })
}

//  获取用户信息
export const getAppUserInfo = params => {
  return request({
    url: 'base/adm/appUserInfo/getAppUserInfoByUserId',
    method: 'get',
    params
  })
}

// 导出
export function downloadData (url, params, title = '') {
  const filePath = baseURL + url + '?' + qs.stringify(params)
  const token = Cookies.get('tvToken') || Cookies.get('token')
  const xhr = new XMLHttpRequest()
  const formData = new FormData()
  xhr.open('GET', filePath, true)
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  xhr.responseType = 'blob'
  xhr.onload = function (e) {
    if (this.status === 200) {
      const blob = this.response

      const filename = title + new Date().getTime() + '.xlsx'
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        const a = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
  }
  xhr.send(formData)
}
